<template>
    <div class="header-container">
      <header class="header-bar">
        <div class="logo-container">
          
            <img src="@/assets/Ansable.svg" alt="Logo" class="logo">
          
        </div>
      </header>
    </div>
  </template>
  
  <script>
 
  export default {
    name: 'WelcomeHeader',
    setup() {
        
    },
    data() {
      return {
        
      }
    },

    }
  </script>
  
  <style scoped>
  .header-container {
    position: relative;
  }
  
  .header-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 10px;
    background-color: #fffff8;
    position: sticky;
    top: 0;
    z-index: 10;
    height: 64px;
  }
  
  .logo-container {
    display: flex;
    align-items: center;
  }
  
  .logo {
    max-height: 50px;
    padding-top: 7px;
  }

  
  </style>